import React from 'react';
import { Container, Typography, Box, CircularProgress, Alert, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useQuery } from 'react-query';
import { useParams, useNavigate } from 'react-router-dom';
import NewsCard from '../components/NewsCard';
import { newsApi } from '../services/api';

const NewsDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: post, isLoading, error } = useQuery({
    queryKey: ['news-post', id],
    queryFn: () => newsApi.getNewsPost(Number(id)),
    enabled: !!id,
  });

  if (isLoading) {
    return (
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 8 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (error || !post) {
    return (
      <Container maxWidth="md">
        <Box sx={{ my: 4 }}>
          <Alert severity="error" sx={{ mb: 3 }}>
            Failed to load news post. It may have been deleted or you don't have permission to view it.
          </Alert>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/news')}
          >
            Back to News
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4 }}>
        <>
          {/* Back Button */}
          <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/news')}
          sx={{ mb: 3 }}
        >
          Back to News
        </Button>

        {/* News Post Card */}
        <NewsCard post={post} showFullContent />
        </>
      </Box>
    </Container>
  );
};

export default NewsDetail;
